import { render, staticRenderFns } from "./Redio.vue?vue&type=template&id=5ea4c16c&scoped=true&"
import script from "./Redio.vue?vue&type=script&lang=js&"
export * from "./Redio.vue?vue&type=script&lang=js&"
import style0 from "./Redio.vue?vue&type=style&index=0&id=5ea4c16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4c16c",
  null
  
)

export default component.exports